import { CommentInputValue, CommentModel } from '@anecdotes/commenting';
import { ChangeDetectionStrategy, Component, HostBinding, HostListener, OnInit } from '@angular/core';
import {
  FocusingService,
  CommentingFacadeService,
  CommentPanelManagerService,
  ConfirmationModalService,
} from '../../services';
import { Observable } from 'rxjs';
import { CommentEntityNameEnum } from '../../models';
import { createComposedResourceId } from '../../utils';
import { AuthService } from '@anecdotes/auth-core';
import { commentDraftLocalStoragePrefix } from '../../constants';
import { BaseThreadComponent } from '../base-thread/base-thread.component';
import { FeatureFlagsService } from '@anecdotes/feature-flags';
import { WindowHelperService } from '@anecdotes/utils';

@Component({
  selector: 'app-active-thread',
  templateUrl: './active-thread.component.html',
  styleUrls: ['./../base-thread/base-thread.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveThreadComponent extends BaseThreadComponent implements OnInit {
  @HostBinding('attr.data-test-id')
  private readonly dataTestId = 'active-thread';

  private localStorage: Storage;
  isFullAccess$: Observable<boolean>;

  constructor(
    protected commentingFacadeService: CommentingFacadeService,
    protected authService: AuthService,
    protected confirmationService: ConfirmationModalService,
    private commentPanelManagerService: CommentPanelManagerService,
    private focusingService: FocusingService,
    private windowHelper: WindowHelperService,
    private featureFlagsService: FeatureFlagsService
  ) {
    super(commentingFacadeService, authService, confirmationService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isFullAccess$ = this.featureFlagsService.isEnabled('@commenting-full-access');
    this.localStorage = this.windowHelper.getWindow().localStorage;
  }

  resolveThread(): void {
    this.commentingFacadeService.resolveThreadAsync(this.resource.threadId);
    this.localStorage.removeItem(`${commentDraftLocalStoragePrefix}-${this.resource.threadId}`);
  }

  editThread(threadId: string, commentInputValue: CommentInputValue): void {
    this.commentingFacadeService.editThreadAsync(threadId, commentInputValue);
  }

  editComment(commentId: string, commentInputValue: CommentInputValue): void {
    this.commentingFacadeService.editCommentAsync(commentId, commentInputValue);
  }

  shouldMenuBeDisplayedForComment(userId: string, comment: CommentModel): boolean {
    return !comment?.isCreationInProgress && this.shouldMenuBeDisplayed(userId);
  }

  async deleteComment(commentId: string): Promise<void> {
    if (await this.confirmationService.openReplyDeleteConfirmation()) {
      this.commentingFacadeService.deleteComment(commentId);
    }
  }

  @HostListener('click', ['$event'])
  private focusResource(): void {
    this.focusingService.focusSingleResource(
      CommentEntityNameEnum.Resource,
      createComposedResourceId(this.resource.resourceType, this.resource.resourceId)
    );
    this.commentPanelManagerService.focusComment(this.resource.resourceType, this.resource.resourceId);
  }
}
